module.exports = __webpack_public_path__ + "img/speaker-1.b3fac239.png";